import { Typography } from "@mui/material";
import { useContext } from "react";

import { purple } from "../config";
import { LangContext } from "../contexts/langContext";

const AmountFound = ({ amountFound, scams }) => {
  const { translatePageText } = useContext(LangContext);
  return (
    <div
      style={{
        display: "inline-flex",
        margin: "0 0 12px 0",
        alignItems: "baseline",
        background: purple[400],
        borderRadius: 12,
        padding: "5px 10px",
        color: "white",
      }}
    >
      <Typography style={{ margin: 0, marginRight: 2 }} variant="h5" component="span">
        {amountFound}
      </Typography>
      <Typography style={{ opacity: 0.8, margin: "0 0 2px 0" }}>
        /{Object.values(scams).length} {translatePageText("general.found")}
      </Typography>
    </div>
  );
};

export default AmountFound;
